import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import TextInputWithLabel from '../TextInputWithLabel';
import MultiSelect from '../MultiSelect';
import SButton from '../Button';
import SelectBox from '../SelectBox';

function ModalInfo({
    handleClose, 
    title,
    content
}) {
    const [isSaving, setIsSaving] = useState(false);
    const [errors, setErrors] = useState({});

    return (
        <>
            <div className='modal modal-lg fade show d-block' style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }} onClick={handleClose}>
                <div className='modal-dialog modal-dialog-centered' onClick={e => e.stopPropagation()} >
                    <div className='modal-content'>
                        <div className='modal-header'>
                            <h5 className="modal-title">{title}</h5>
                            <SButton variant={''} className={"btn-close"} action={handleClose} />     
                        </div>
                        <div className='modal-body'>
                            {content}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ModalInfo;
